import lineAnimation from '@fusioncharts/charts/src/dataset/line/index.animation';

export default {
  'initial.dataset.errorScatter': lineAnimation['initial.dataset.line']
};
